export const reducer = (state, action) => {
  switch (action.type) {
    case "SWITCH_LANGUAGE":
      return {
        ...state,
        lang: action.payload,
      };

    default:
      return state;
  }
};

export const initialState = {
  lang: "it",
};
